
export const GetCabinClass = (cabinCls, resourceKeys) =>
{
    switch (cabinCls) {
        case 'Y':
            return resourceKeys?.flight_economy || 'Economy';
        case 'W':
            return resourceKeys?.flight_premium_economy || 'Premium Economy';
        case 'C':
            return resourceKeys?.flight_business_class || 'Business Class';
        case 'F':
            return resourceKeys?.flight_first_class || 'First Class';
        default:
            return resourceKeys?.flight_economy || 'Economy';
    }
}



export const validateField = (name, value, resourceKeys) => {
    switch (name) {
      case "firstName":
        return value.trim() ? "" : resourceKeys.First_Name_is_required +".";
      case "lastName":
        return value.trim() ? "" : resourceKeys.last_name_required +".";
      case "email":
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ""
          : resourceKeys.enter_valid_email +".";
      case "mobile":
        return /^\d{10}$/.test(value) ? "" : resourceKeys.enter_valid_ten_digit +".";
    case "message":
        return value.trim() !== "" ? "" : resourceKeys.message_cannot_be_empty;
        
      default:
        return "";
    }
  };